export const contact = {
  modal: {
    remove: {
      content: `Anda yakin ingin menghapus kontak <b>{contact}<b>?`
    }
  },

  form: {
    title: {
      edit: {
        main: 'Kontak data'
      }
    }
  },

  table: {
    field: {
      first_name: 'Nama Depan',
      last_name: 'Nama Akhir',
      full_name: 'Nama Lengkap',
      email: 'E-mail',
      contact_methods: 'Metode Kontak',
      contact_method: 'Metode Kontak',
      label: 'Icon'
    }
  }
};
